import React from 'react';
import { NavLink } from 'react-router-dom';

const MenuItem = ({ location, title, icon, advanced, tenantPath }) => (
  <NavLink to={`${tenantPath}${location}`} className="side-navigation-menu-item">
    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 5 }}>
      {React.isValidElement(icon) && React.cloneElement(icon, { style: { fontSize: 20 } })}
      <span style={{ visibility: `${advanced ? 'visible' : 'hidden'}` }}>*</span>
      <span style={{ marginLeft: 2 }}>{title}</span>
    </div>
  </NavLink>
);

export default MenuItem;
